import onKeyboardToggleFlagState from '../actions/actionCreators/onKeyboardToggleFlagState';
import { orchestrator } from 'satcheljs';
import toggleRowsFlagState from 'owa-mail-triage-action/lib/actions/toggleRowsFlagState';
import setItemsFlagStateBasedOnNodeIds from 'owa-mail-triage-action/lib/actions/actionCreators/setItemsFlagStateBasedOnNodeIds';
import { isFirstLevelExpanded } from 'owa-mail-list-store/lib/selectors/isConversationExpanded';
import getItemForMailList from 'owa-mail-store/lib/selectors/getItemForMailList';
import {
    doesUserHaveSharedFolderPermissionFor,
    MenuItemType,
} from 'owa-mail-filterable-menu-behavior';
import FlagStatus from 'owa-service/lib/contract/FlagStatus';
import { isConsumer } from 'owa-session-store';

// Orchestrator for keyboard toggle flag on both item parts and rows
export default orchestrator(onKeyboardToggleFlagState, actionMessage => {
    const { tableView, selectedNodeIds, selectedRowKeys } = actionMessage;

    // Disable flag toggling for shared folders if the user doesn't have the permission
    if (!doesUserHaveSharedFolderPermissionFor(MenuItemType.Flag)) {
        return;
    }

    // Is item part operation
    if (selectedNodeIds.length > 0) {
        const flagStatusToApply = getItemFlagStatusToApply(
            selectedNodeIds,
            isFirstLevelExpanded(selectedRowKeys[0])
        );
        setItemsFlagStateBasedOnNodeIds(
            selectedNodeIds,
            tableView.id,
            flagStatusToApply,
            'Keyboard'
        );
        // Is row operation
    } else {
        if (selectedRowKeys.length === 0) {
            return;
        }

        toggleRowsFlagState(selectedRowKeys, tableView.id, 'Keyboard' /* actionSource */);
    }
});

function getItemFlagStatusToApply(
    selectedNodeIds: string[],
    isFirstLevelExpanded: boolean
): FlagStatus {
    for (let nodeId of selectedNodeIds) {
        const item = getItemForMailList(nodeId, isFirstLevelExpanded);
        // Set the FlagStatus to 'Flagged' if there is any non-flagged item
        if (item.Flag.FlagStatus !== 'Flagged') {
            return 'Flagged';
        }
    }
    return !isConsumer() ? 'Complete' : 'NotFlagged';
}
